import React from 'react';
import * as Scrivito from 'scrivito';
import { Helmet } from 'react-helmet-async';

const SCRIVITO_TENANT = import.meta.env.VITE_SCRIVITO_TENANT;

// Scrivito's cloud UI has no standalone login page – it authenticates you
// (via Google/JustRelate SSO) and drops you into the editor for a specific
// tenant + URL using the path scheme https://edit.scrivito.com/{tenant}~{targetUrl}.
function scrivitoEditUrl() {
  return `https://edit.scrivito.com/${SCRIVITO_TENANT}~${window.location.origin}/`;
}

const LoginPage = Scrivito.connect(() => {
  const loggedIn = Scrivito.isEditorLoggedIn();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="card shadow-sm" style={{ width: 360 }}>
          <div className="card-body p-4 text-center">
            <h4 className="mb-4">Trans Tech CMS</h4>
            {loggedIn ? (
              <>
                <p className="text-success mb-3">Logged in as editor</p>
                <a href="/" className="btn btn-primary me-2">Go to site</a>
                <button className="btn btn-outline-secondary" onClick={() => Scrivito.logout()}>
                  Logout
                </button>
              </>
            ) : (
              <>
                <p className="text-muted mb-3">Edit content via the Scrivito platform</p>
                <a className="btn btn-primary w-100" href={scrivitoEditUrl()}>
                  Open Scrivito Editor
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default LoginPage;
